module.exports = new __parcel__URL__("jiro-dreams-of-sushi.6ed0b8cf.jpg").toString();